<div class="search-container">
    <div class="search-bar-wrapper">
        <div class="input-wrapper">
            <input #searchInputRef type="text" class="search-input" placeholder="Search Tax Agent BIN"
                [(ngModel)]="searchValue" (keyup.enter)="onSearch()" [disabled]="searchDisabled" inputmode="numeric"
                pattern="[0-9]*" (keypress)="allowOnlyNumbers($event)" (input)="sanitizeNumericInput($event)"
                (paste)="handlePaste($event)" />
            <mat-icon class="search-icon" [class.disabled]="!searchValue" [attr.aria-disabled]="!searchValue"
                (click)="searchIconClicked()">
                {{ searchValue ? 'close' : 'search' }}
            </mat-icon>
        </div>
        <button class="search-btn" (click)="onSearch()" [disabled]="searchDisabled || !searchValue">Search</button>
    </div>

    <div *ngIf="showResults" class="results-container">
        <div class="found-section">
            <div class="found-header">
                <mat-icon class="check-icon">check_circle</mat-icon>
                <span class="found-text">BIN Found!</span>
            </div>

            <div class="agent-details">
                <div class="detail-row header-row">
                    <span class="label" *ngFor="let header of getFilteredHeadings()">{{ header }}</span>
                </div>
                <div class="detail-row data-row">
                    <span class="value" *ngFor="let item of getFilteredData()">{{ item }}</span>
                </div>
            </div>
        </div>

        <!-- Added showServiceTable to hide currently for now -->
        <div class="table-wrapper" *ngIf="showServiceTable">
            <app-table [tableType]="'radioInfoTable'" [displayedColumns]="displayedColumns"
                [externalDataSource]="dataSource" [responseData]="responseData" [infoColumns]="infoColumns"
                [(selectedValue)]="selectedLevel" [showPagination]="true" [noPagination]="true"></app-table>
        </div>

        <form [formGroup]="agentForm" (ngSubmit)="onAppointAgent()">
            <div class="action-buttons">
                <button mat-button class="cancel-btn" type="button" (click)="onCancel()">Cancel</button>
                <div>
                    <!-- <p [matTooltip]="!selectedLevel ? 'Please select a level to appoint agent' : ''"
                    [matTooltipDisabled]="!!selectedLevel" ></p> -->
                    <!-- <button mat-raised-button class="appoint-btn" type="submit" [disabled]="!selectedLevel">Appoint
                        Agent</button> -->
                    <button mat-raised-button class="appoint-btn" type="submit">Appoint
                        Agent</button>
                </div>
            </div>
        </form>
    </div>

    <div class="content empty-state" *ngIf="showContent">
        <mat-icon>search_off</mat-icon>
        <p class="hint">
            No data available for the entered BIN.
        </p>
        <button class="clear-filters-btn" (click)="onCancel()">Clear Filters</button>
    </div>
</div>